export default function StarshipSneakIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#141A3E" />
      <circle cx="12" cy="12" r="1.6" fill="#FFFFFF" />
      <circle cx="54" cy="46" r="1.4" fill="#BFE6FF" />
      <circle cx="9" cy="44" r="1.1" fill="#FFFFFF" />
      <path d="M26 22Q22 14 19 10M38 22Q42 14 45 10" stroke="#141622" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="19" cy="10" r="3.5" fill="#FFB0B8" stroke="#141622" strokeWidth="2" />
      <circle cx="45" cy="10" r="3.5" fill="#FFB0B8" stroke="#141622" strokeWidth="2" />
      <ellipse cx="24" cy="53" rx="6" ry="3.5" fill="#C2304A" stroke="#141622" strokeWidth="2.2" />
      <ellipse cx="40" cy="53" rx="6" ry="3.5" fill="#C2304A" stroke="#141622" strokeWidth="2.2" />
      <path
        d="M32 15q4-3 7 1q5-1 6 4q5 1 5 6q4 3 1 7q2 5-2 7q0 5-5 6q-2 4-7 3q-3 3-7 0q-5 1-7-3q-5-1-5-6q-4-2-2-7q-3-4 1-7q0-5 5-6q1-5 6-4q3-4 7-1z"
        fill="#FF5C6C"
        stroke="#141622"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <ellipse cx="34" cy="41" rx="8" ry="6" fill="#FFB0B8" />
      <ellipse cx="27" cy="30" rx="5" ry="6" fill="#FFFFFF" stroke="#141622" strokeWidth="2" />
      <ellipse cx="39" cy="30" rx="5" ry="6" fill="#FFFFFF" stroke="#141622" strokeWidth="2" />
      <circle cx="28.5" cy="31" r="2.6" fill="#141622" />
      <circle cx="40.5" cy="31" r="2.6" fill="#141622" />
      <path d="M30 38q3 3 6 0" stroke="#141622" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
